import React, { useState, useEffect } from "react";
import { Box, Button, Hidden, IconButton, makeStyles, useTheme, useMediaQuery, Grid, Drawer, ButtonGroup } from "@material-ui/core";
import { CgMenuGridR } from "react-icons/cg";
import { Books, Orders, Profile, Settings, Wishlist, Notifications, Articles } from "./components";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import { MyAdverBooks } from "./DownloadedBooks";
import { useLocation, useHistory } from "react-router-dom";
import tabs from "./tabs";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "220px",
    height: "100%",
    backgroundColor: "black",
    color: "white",
  },
  tabs: {
    marginTop: "30px",
  },
  tabBtn: {
    color: "black",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    padding: "10px",
  },
  drawerBtn: {
    color: "white",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    padding: "10px",
  },
  activeTabBtn: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "flex-start",
    padding: "10px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

function Customer() {
  const [openTab, setOpenTab] = useState(false);
  const location = useLocation();
  const classes = useStyles();
  const theme = useTheme();
  const state = useSelector((state) => state.customer);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [tabPanelIndex, setTabPanelIndex] = useState(getInitialTab());

  
  const history = useHistory();

  useEffect(() => {
    if (location.state && location.state.activeTab) {
      setTabPanelIndex(location.state.activeTab);
    }
  }, [location]);

  function getInitialTab() {
    // Check if there's a valid tab index in the URL state
    if (location.state && location.state.activeTab) {
      return location.state.activeTab;
    }
    // If not, return the index of the first tab in the tabs array
    return tabs[0].panel;
  }

  const toggleTabView = () => {
    setOpenTab(!openTab);
  };

  const handleTabClose = () => {
    setOpenTab(false);
  };

  return (
    <div>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <Hidden only={["lg", "xl", "md"]}>
          <IconButton
            onClick={toggleTabView}
            style={{
              backgroundColor: theme.palette.primary.main,
              marginTop: "-25px",
            }}
          >
            <CgMenuGridR />
          </IconButton>
        </Hidden>
      </Box>

      <Hidden only={["lg", "xl", "md"]}>
        <Drawer
          classes={{ paper: classes.drawer, modal: classes.drawerModal }}
          anchor="left"
          open={isDesktop ? true : openTab}
          variant={isDesktop ? "permanent" : "temporary"}
          onClose={handleTabClose}
        >
          {tabs.map((tab, index) => (
            <Button
              startIcon={
                tab.panel === tabPanelIndex ? tab.activeIcon : tab.icon
              }
              key={index}
              className={
                tab.panel === tabPanelIndex
                  ? classes.activeTabBtn
                  : classes.drawerBtn
              }
              onClick={() => {
                setTabPanelIndex(tab.panel);
                handleTabClose();
              }}
              align="left"
              fullWidth
            >
              {tab.name}
            </Button>
          ))}
        </Drawer>
      </Hidden>
      <Grid container spacing={5}>
        <Grid item xs={12} md={3} lg={2}>
          <Hidden only={["xs", "sm"]}>
            <div className={classes.tabs}>
              <ButtonGroup orientation="vertical" fullWidth>
                {tabs.map((tab, index) => (
                  <Button
                    startIcon={
                      tab.panel === tabPanelIndex ? tab.activeIcon : tab.icon
                    }
                    key={index}
                    className={
                      tab.panel === tabPanelIndex
                        ? classes.activeTabBtn
                        : classes.tabBtn
                    }
                    onClick={() => setTabPanelIndex(tab.panel)}
                    align="left"
                    fullWidth
                  >
                    {tab.name}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
          </Hidden>
        </Grid>
        <Grid item xs={12} md={9} lg={10}>
          {state.user ? (
            <>
              {tabPanelIndex === 0 && <Profile user={state.user} />}
              {tabPanelIndex === 1 && <Orders />}
              {tabPanelIndex === 2 && <Wishlist user={state.user} />}
              {tabPanelIndex === 3 && <Settings user={state.user} />}
              {tabPanelIndex === 4 && <Books />}
              {tabPanelIndex === 5 && (
                <Notifications userId={state.user.user._id} />
              )}
              {tabPanelIndex === 8 && <MyAdverBooks user={state.user} />}
              {tabPanelIndex === 7 && <Articles userId={state.user.user._id} />}
            </>
          ) : (
            <Skeleton animation="wave" />
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default Customer;
